export default {
  setConversations(state, conversations) {
    state.conversations = [...state.conversations, ...conversations]
  },
  clearConversations(state) {
    state.conversations = []
  },
  deleteConversation(state, conversationId) {
    state.conversations = state.conversations.filter(conversation => conversation.id !== conversationId)
  },
}
